export default {
  network: {
    normal: "未知のエラー",
    unavailable: "インターネットに接続されていません、電波状況を確かめください",
    failedReceiveMessage: "メッセージの受信に失敗しました",
    disconnect: "接続の切断",
    failedReceiveHistoryMessage: "チャット履歴の取得に失敗しました",
    // succeededReceiveHistoryMessage: "获取历史消息成功",
    failedLike: "いいね失敗",
    succeededLike: "いいね成功",
  },
  chatInput: {
    inputPrompt: "入力してください",
  },
  tip: {
    aiTip:
      "この内容はAIによって生成されたものです、不正確な情報を生成する可能性があります",
    loading: "Loading...",
  },
  mesage: {
    like: "いいね ",
    teach: "ダメだね",
    makeMeBetter: "もっと良くなるようにしてください",
    teachMe: "教えて",
    betterAnswer: "もっと正しく質の良い答えを残してください",
    throwLink: "リンクを送る",
    correctAnswer: "もっと勉強するので、正しい答えのリンクを貼ってください",
    pickTeachReson: "せめて「ダメだね」の理由を一つは選びましょう",
    feedSucessed: "フィードバック成功です",
    submit: "提出する",
  },
  time: {
    year: "年",
    month: "月",
    day: "日",
    monday: "月曜日",
    tuesday: "火曜日",
    wednesday: "水曜日",
    thursday: "木曜日",
    friday: "金曜日",
    saturday: "土曜日",
    sunday: "日曜日",
    yesterday: "昨日",
  },
  topic: {
    recommendedReply: "推薦の答え：",
    nextTopic: "次の話題：",
    refresh: "再読み込み", // 刷新话题按钮
    promptHeading: "再読み込みをクリックすると新しい話題が提供されます", // 刷新话题提示语
    noMoreReminders: "もう表示しない", // 刷新话题弹窗 [不再提醒]按钮
    cancle: "取り消し", // 刷新话题弹窗 [取消]按钮
    confirm: "確認", // 刷新话题弹窗 [确定]按钮
    noMoreTopics:
      "現在、話題はこれ以上ありません、努力して生産中のでお楽しみに(๑･◡´･๑)",
  },
};
